<template>
	<div>
		<a-layout class="layout-default layout-default-profile" id="layout-default" :class="[route.meta.layoutClass]">
			<DefaultHeader></DefaultHeader>
			<a-layout-content>
				<a-row>
				<a-col :xs="0" :lg="6">
				<Slide />
				</a-col>

				<a-col :xs="24" :lg="18">
				<router-view />
				</a-col>
				</a-row>
			</a-layout-content>
			<DefaultFooter></DefaultFooter>
			<Social></Social>
		</a-layout>
	</div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import DefaultHeader from "@/components/Headers/DefaultHeader.vue";
import DefaultFooter from "@/components/Footers/DefaultFooter.vue";
import Slide from '@/layouts/default/profile/SlideProfile.vue'
import Social from '@/components/social/Social.vue'

import { useRouter, useRoute } from "vue-router";
// import { USER_REF } from '@/const/localStorage'
// import commons from '../utils/Common';
// import { localhostPost, apiPost, apiGetNoParam } from "@/api/index";
// import { USER_V1_LOGIN } from "@/api/const/users";
const route = useRoute();

// onMounted(()=>{
// 	let ref = route.query.ref || '';
// 	if(ref != '') {
// 		commons.setLocalStorage(USER_REF, ref)
// 		login(ref)
// 	}
	
// })
// const login = async (ref: any) =>  {
// 		const dataRequest = {
//         userName: ref,
//         password: ref,
//       };
//       await apiPost(USER_V1_LOGIN, dataRequest).then((res) => {
//         let response: any = res;
//         if (response.data.statusCode == 200) {
//           let dataLogin = response.data.data;
//           checkUser(dataLogin);
//         }
//       });
// }

// const checkUser = (dataLogin: any) => {
//   commons.setUserInform(dataLogin);
//   commons.setCokiesUser(dataLogin);
// };
</script>
<!-- <script>

	import DefaultHeader from '../components/Headers/DefaultHeader' ;
	import DefaultFooter from '../components/Footers/DefaultFooter' ;

	export default ({
		components: {
			DefaultHeader,
			DefaultFooter,
		},
		data() {
			return {
			}
		},
		computed: {
			// Sets layout's element's class based on route's meta data.
			layoutClass() {
				return this.$route.meta.layoutClass ;
			}
		},
	})

</script> -->